// Drop default reply rows the user added but never filled in. A blank entry
// must not persist: the widget selects by array length, so a stored [""]
// counts as "configured" and renders one empty chip instead of falling
// through. Stripped at save rather than in the editor's onChange, so a
// freshly added empty row can still exist while it is being edited.
// Page contexts are not in this form at all (see widgetConfigApi); their
// blank rows are stripped by `withoutBlanks` in PageContextsBrowser.
//
// Módulo próprio, ao lado do setOrDelete, pela mesma razão que ele: é uma função
// pura, o contrato dela vale por si, e assim os testes chegam-lhe sem arrastar o
// grafo de imports da página (ChatContext, AuthContext, widgetConfigApi,
// PreviewPane) atrás de uma função de trinta linhas.
export const stripBlanks = (copy) => {
  // Trim as well as filter: PatternListField already trims patterns, so
  // without this the two halves of the same feature disagree and the padding
  // renders inside the chip. Trimming at save, never on change — trimming a
  // controlled input on every keystroke eats the spaces between words.
  const keep = (arr) =>
    Array.isArray(arr)
      ? arr
          .map((s) => (typeof s === "string" ? s.trim() : s))
          .filter((s) => typeof s === "string" && s)
      : [];

  const next = { ...copy };

  const defaults = keep(next.welcomeQuickReplies);
  if (defaults.length) next.welcomeQuickReplies = defaults;
  else delete next.welcomeQuickReplies;

  // As traduções levam o mesmo tratamento que o topo: um idioma que fique sem
  // campos nenhuns sai do mapa, em vez de ficar lá um objecto vazio a dizer
  // "configurado com nada". Entradas novas de cada vez, e não as do formulário:
  // um save falhado deixa o formulário em ecrã, e o que ele mostra tem de ser o
  // que o operador escreveu.
  if (next.translations && typeof next.translations === "object") {
    const translations = {};
    for (const [loc, entry] of Object.entries(next.translations)) {
      const replies = keep(entry?.welcomeQuickReplies);
      const cleaned = { ...entry };
      if (replies.length) cleaned.welcomeQuickReplies = replies;
      else delete cleaned.welcomeQuickReplies;
      for (const [k, v] of Object.entries(cleaned)) {
        if (v === null || v === "" || (typeof v === "string" && !v.trim())) delete cleaned[k];
      }
      if (Object.keys(cleaned).length) translations[loc] = cleaned;
    }
    if (Object.keys(translations).length) next.translations = translations;
    else delete next.translations;
  }

  return next;
};
